import { format } from 'date-fns'
import { Formik } from 'formik'
import React from 'react'
import { useMutation } from '@apollo/client/react'

import { Time } from '../../../common/types'
import { Button } from '../../../components/Button'
import { setSuccessNotification, setUnauthorizedNotification } from '../../../components/notification'
// import { setGenericErrorNotification } from '../../../components/notification/genericResponseErrorNotification'
import { Loading } from '../../../components/responses'
import { setFatalErrorNotification } from '../../../components/responses/setErrorNotifications'
import { useHistoryPush } from '../../../components/router'
import { ButtonContainer, RouteForm as EventForm } from '../../TowingRecordPage/components/routes/subforms/styled'
import { ADD_EVENT_MUTATION, AddEventResponse } from '../mutation/mutations'
import { toMutationVariables } from '../mutation/toMutationVariables'
import { CurrentWorkShift, EventTypeOption } from '../types'
import { AddEvent } from './AddEvent'
import { AddEventFormValues } from './types'
import { GET_CURRENT_SHIFT } from '../ShiftQuery'
import { formatMessageSafe } from '../../../util/translateInputOptions'
import { defineMessages, useIntl } from 'react-intl'
import { messages as buttonMessages } from '../../../components/Button/messages'

interface AddEventPageProps {
  type: EventTypeOption
  onClose: () => void
  shift: CurrentWorkShift
  refetch: () => void
}

const messages = defineMessages({
  create_title: {
    id: 'shift.event.created.title',
    defaultMessage: 'Event created',
  },
  create_message: {
    id: 'shift.event.created.message',
    defaultMessage: 'Event created',
  },
})

const AddEventPageIntl: React.FunctionComponent<AddEventPageProps> = ({
  type,
  onClose,
  shift,
  refetch,
}) => {
  const intl = useIntl()
  const formatMessage = formatMessageSafe(intl)
  const historyPush = useHistoryPush()

  const [addEvent, { loading }] = useMutation<AddEventResponse>(ADD_EVENT_MUTATION, {
    refetchQueries: [{ query: GET_CURRENT_SHIFT }],
    onCompleted(response) {
      console.log('response', response)
      if (response.addEvent.__typename === 'AddEventSuccess') {
        setSuccessNotification(formatMessage(messages.create_title), formatMessage(messages.create_message))
        historyPush(`/shifts`)
      }
      if (response.addEvent.__typename === 'UnauthorizedError') {
         setUnauthorizedNotification()
      }
    },
    onError(err) {
      // console.error(err.message)
      // const keyword = `Message:`
      // const message = err.message

      // const parsedMessage = message.slice(message.indexOf(keyword) + keyword.length)
      // console.log('parsedMessage', parsedMessage)
      // if (parsedMessage.length > 0) {
      //   setGenericErrorNotification('Virhe', parsedMessage)
      //   return refetch()
      // }

      setFatalErrorNotification(err)
      return refetch()
    },
  })
  console.log(shift)
  const initialValues = getInitialValues()
  return (
    <Formik
      initialValues={initialValues}
      onSubmit={(values: AddEventFormValues) => addEvent({ variables: toMutationVariables(values, type, shift) })}
    >
      {({ setFieldValue, values }) => {
        const setCurrentTime = (prefix: string) => {
          const date = new Date()
          setFieldValue(`${prefix}.date`, date)
          setFieldValue(`${prefix}.time`, (format(date, 'HH:mm') as unknown) as Time)
        }
        return (
          <EventForm>
            <AddEvent type={type} onClose={onClose} setCurrentTime={setCurrentTime} setFieldValue={setFieldValue} values={values} />
            <ButtonContainer floatAtBottom>
              <Loading loading={loading} />
              <Button category="save" size="l" label={formatMessage(buttonMessages.save)} submit maxWidth="100%"></Button>
            </ButtonContainer>
          </EventForm>
        )
      }}
    </Formik>
  )
}

export const AddEventPage = AddEventPageIntl

function getInitialValues(): AddEventFormValues {
  return {
    event: { date: new Date(), time: (format(new Date(), 'HH:mm') as unknown) as Time, comment: '', estimatedEnd: {date: null, time: null}},
  }
}
